import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Button from '../../../shared/Button'
import { Unless } from '../../..'
import { IconCommentingFa } from '../../../shared/Icon'

import styles from './DirectMessageButton.module.scss'

const defaultProps = {
  loading: false,
}

const propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
  onMouseOut: PropTypes.func,
}

const DirectMessageButton = ({
  loading,
  className,
  onMouseOut = null,
  ...restProps
}) => {
  return (
    <Button
      data-qa='directMessageButton'
      aria-label='send direct message'
      primaryCustom
      compact
      className={classnames(
        styles.button,
        loading && styles.loading,
        className
      )}
      onMouseOut={e => {
        e.target.blur()
        onMouseOut && onMouseOut()
      }}
      {...restProps}
    >
      <Unless condition={loading}>
        <IconCommentingFa className={styles.icon} />
      </Unless>
    </Button>
  )
}

DirectMessageButton.defaultProps = defaultProps
DirectMessageButton.propTypes = propTypes

export default DirectMessageButton
